import Marquee from "react-fast-marquee";
import { content } from "../i18n/content";

export const EditorialMarquee = () => (
  <div className="relative py-8 sm:py-12 bg-[#1e1b1b] overflow-hidden" data-testid="editorial-marquee">
    <Marquee speed={28} gradient={false} pauseOnHover>
      {content.marquee.map((item, i) => (
        <span key={i} className="flex items-center">
          <span
            className={`font-display text-2xl sm:text-4xl mx-8 sm:mx-12 tracking-tight ${
              i % 2 === 0 ? "text-[#f9f6f0]" : "italic font-light text-[#c86f53]"
            }`}
          >
            {item}
          </span>
          <span className="w-2 h-2 rotate-45 bg-[#f9f6f0]/25" />
        </span>
      ))}
    </Marquee>
  </div>
);
